import { TranslocoDirective, provideTranslocoScope } from '@jsverse/transloco';
import { Component, Inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

export interface TaskProductChangesConfirmDialogData {
  comment: string;
}

@Component({
  providers: [provideTranslocoScope('tasks')],
  selector: 'task-product-changes-confirm-dialog',
  imports: [
    MatButtonModule,
    MatDialogModule,
    ReactiveFormsModule,
    TranslocoDirective,
  ],
  templateUrl: './task-product-changes-confirm-dialog.html',
  styleUrl: './task-product-changes-confirm-dialog.scss',
})
export class TaskProductChangesConfirmDialog {
  readonly form;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: TaskProductChangesConfirmDialogData,
    private readonly dialogRef: MatDialogRef<TaskProductChangesConfirmDialog, string>,
    formBuilder: FormBuilder,
  ) {
    this.form = formBuilder.nonNullable.group({
      comment: [data.comment, [Validators.required]],
    });
  }

  confirm(): void {
    const comment = this.form.controls.comment.value.trim();
    if (!comment) return;

    this.dialogRef.close(comment);
  }
}
